// Decode data from Matrix ^rawurlencode
// Alternative to using base64 for matrix data
export const cleanString = (str: string): string =>
  decodeURIComponent(str)
    .replace(/(&#39;|&rsquo;)/g, "'")
    .replace(/&amp;/g, '&');

// Render html in react component
interface IcreateMarkup {
  __html: string;
}

export const createMarkup = (html: string): IcreateMarkup => ({ __html: html });
